import { CardBase, Text, View, Button } from '@/components'
import { ViewProps } from '@codeleap/web'
import { ProgressCircle } from '../../../../components/Progress/Circle'
import { useAppI18N } from '@/app'

type OrganisationScoreCardProps = {
  begginerProgress: number
  headProgress: number
  heartProgress: number
  handProgress: number
  views: number
  lastViwed: string
} & Partial<ViewProps<'div'>>

export function OrganisationScoreCard(props: OrganisationScoreCardProps) {
  const {
    views,
    lastViwed,
    begginerProgress,
    headProgress,
    heartProgress,
    handProgress,
    ...otherProps
  } = props
  const { t } = useAppI18N()

  return (
    <CardBase
      debugName='Organisation score card'
      variants={[
        'backgroundColor:neutral1',
        'padding:4',
        'border-radius:medium',
        'card:elevated',
        'inlineFlex',
        'column',
      ]}
      {...otherProps}
    >
      <Text
        text={t('organisations.scoreTitle')}
        variants={['h3', 'color:neutral9', 'marginBottom:2']}
      />
      <View variants={['justifySpaceAround']}>
        <View variants={['inlineFlex', 'column', 'marginRight:8']}>
          <ProgressCircle
            progress={begginerProgress}
            text='Foundational'
            icon='baby'
          />
          <View
            variants={[
              'flex',
              'column',
              'alignCenter',
              'justifyCenter',
              'marginTop:1',
            ]}
          >
            <Text
              text={`${begginerProgress}%`}
              variants={['h1', 'color:neutral9']}
            />
            <Text text='average Score' variants={['p4', 'color:neutral5']} />
          </View>
        </View>

        <View
          variants={['w:0.25', 'paddingVertical:1', 'backgroundColor:neutral3']}
        >
          <View variants={['fullWidth', 'backgroundColor:neutral3']} />
        </View>

        <View variants={['inlineFlex', 'column', 'gap:2', 'marginLeft:8']}>
          <ProgressCircle
            variants={['small']}
            progress={headProgress}
            icon='head-outline'
            text='Head'
          />
          <ProgressCircle
            variants={['small']}
            progress={heartProgress}
            icon='heart'
            text='Heart'
          />
          <ProgressCircle
            variants={['small']}
            progress={handProgress}
            icon='hand'
            text='Hands'
          />
        </View>
      </View>

      <Text
        variants={['p5', 'color:neutral5', 'textCenter', 'marginVertical:2']}
        text={`${views} reviews, last reviewed ${lastViwed}`}
      />

      <Button
        variants={['minimal', 'small', 'gap:1']}
        text={`See more details`}
        debugName={`Pressed see more details`}
        rightIcon='expand'
      />
    </CardBase>
  )
}
